import { gatewayPageBuilder } from "../../../../gateways/gatewayPageBuilder";

export const getMyQuota = async (): Promise<any> => {
    const token = sessionStorage.getItem("token");

    if (!token) {
        throw new Error("No auth token found");
    }

    const { data } = await gatewayPageBuilder.get("page-builder/quota", {
        headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
    });

    return data;
};
